import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Change to useNavigate
import Loader2 from "../Skleton/Loader2";

function Agencylogin() {
  const [agid, setagid] = useState("");
  const [password, setPassword] = useState("");
  const [error, seterror] = useState(false);
  const [isloading, setisloading] = useState(false)

  const navigate = useNavigate(); // Change to useNavigate

  useEffect(() => {
    const storedEmail = localStorage.getItem('Agencyid');
    if (storedEmail) {
      navigate('/agencyachivements'); // Use navigate function
    }
  }, [navigate]);

  async function handleSubmit(e) {


    setisloading(true);
    e.preventDefault();

    const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/agencysignin', {
      method: 'POST',
      body: JSON.stringify({ agid, password }),
      headers: { 'Content-Type': 'application/json' },
    });
    const post = await res.json();
    setisloading(false)

    if (post === "valid") {
      localStorage.setItem('Agencyid', agid);


      window.location.href = "/agencyachivements";

      // navigate('/agencyachivements'); 
    } else {
      seterror(true);
    }
  }

  return (<>
  <br />
  <br />
{isloading?<>


<Loader2/>

</>:<>



<br />
    <div className="flex justify-center    h-screen bg-gray-100">
<div className="w-96 p-6 bg-white rounded-lg shadow-md flex flex-col items-center space-y-4"   style={{ height: "70vh" }}>
        <h2 className="text-2xl font-semibold">AGENCY LOGIN</h2>
        <br />
        <br />
        <form onSubmit={handleSubmit} className="w-full">
          <div className="mb-4">
            <label htmlFor="email" className="block mb-1">
              Agency Id
            </label>
            <input
              value={agid}
              onChange={(e) => setagid(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="password" className="block mb-1">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>
          <button
            type="submit"
            className="w-full py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-700"
          >
            Login
          </button>

          {error ? (
            <>
              <p className="mt-4"    text-red-600   >invalid credentials</p>
            </>
          ) : (
            <></>
          )}
        </form>
        <p className="mt-4 text-blue-500 "    onClick={()=>navigate('/agencyreg')}>
          Don't have an account? Register
        </p>
      </div>
    </div>





</>}


    </>
  );
}

export default Agencylogin;
